import { forwardRef } from 'react';

export const TownhouseIcon = forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>(
  function Icon(props, ref) {
    return (
      <svg
        ref={ref}
        width="42"
        height="42"
        viewBox="0 0 42 42"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g clipPath="url(#clip0)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M29.6636 7.98282C29.864 7.82995 30.1408 7.82609 30.3454 7.97331L39.7381 14.7315C39.8877 14.8391 39.9764 15.0121 39.9764 15.1964V34.1728C39.9764 34.4891 39.7199 34.7455 39.4036 34.7455H20.6946C20.3782 34.7455 20.1218 34.4891 20.1218 34.1728C20.1218 33.8564 20.3782 33.6 20.6946 33.6H38.8309V15.4899L30.0209 9.15093L21.3473 15.7663C21.0958 15.9581 20.7364 15.9098 20.5446 15.6583C20.3528 15.4068 20.4012 15.0474 20.6527 14.8555L29.6636 7.98282Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M29.6888 5.06282C29.8875 4.92765 30.1494 4.93088 30.3447 5.07091L42.2193 13.5855C42.4763 13.7698 42.5353 14.1276 42.351 14.3846C42.1666 14.6417 41.8088 14.7007 41.5518 14.5163L30.0024 6.23492L21.0168 12.3481C20.7552 12.526 20.399 12.4582 20.2211 12.1967C20.0432 11.9352 20.1109 11.5789 20.3725 11.401L29.6888 5.06282Z"
            fill="currentColor"
          />
          <path d="M27.9491 18.2891H24.5891V22.4891H27.9491V18.2891Z" fill="currentColor" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.0164 18.289C24.0164 17.9727 24.2728 17.7163 24.5891 17.7163H27.9491C28.2654 17.7163 28.5218 17.9727 28.5218 18.289V22.489C28.5218 22.8053 28.2654 23.0618 27.9491 23.0618H24.5891C24.2728 23.0618 24.0164 22.8053 24.0164 22.489V18.289ZM25.1618 18.8618V21.9163H27.3764V18.8618H25.1618Z"
            fill="currentColor"
          />
          <path d="M35.2036 18.2891H31.8436V22.4891H35.2036V18.2891Z" fill="currentColor" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M31.2709 18.289C31.2709 17.9727 31.5273 17.7163 31.8436 17.7163H35.2036C35.5199 17.7163 35.7763 17.9727 35.7763 18.289V22.489C35.7763 22.8053 35.5199 23.0618 35.2036 23.0618H31.8436C31.5273 23.0618 31.2709 22.8053 31.2709 22.489V18.289ZM32.4163 18.8618V21.9163H34.6309V18.8618H32.4163Z"
            fill="currentColor"
          />
          <path d="M27.9491 25.5054H24.5891V29.7054H27.9491V25.5054Z" fill="currentColor" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.0164 25.5053C24.0164 25.189 24.2728 24.9326 24.5891 24.9326H27.9491C28.2654 24.9326 28.5218 25.189 28.5218 25.5053V29.7053C28.5218 30.0217 28.2654 30.2781 27.9491 30.2781H24.5891C24.2728 30.2781 24.0164 30.0217 24.0164 29.7053V25.5053ZM25.1618 26.0781V29.1326H27.3764V26.0781H25.1618Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M31.2709 25.5053C31.2709 25.189 31.5273 24.9326 31.8436 24.9326H35.2036C35.5199 24.9326 35.7763 25.189 35.7763 25.5053V34.1726C35.7763 34.4889 35.5199 34.7453 35.2036 34.7453H31.8436C31.5273 34.7453 31.2709 34.4889 31.2709 34.1726V25.5053ZM32.4163 26.0781V33.5999H34.6309V26.0781H32.4163Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.3491 7.97331C11.5503 7.82855 11.8218 7.82964 12.0218 7.976L21.4145 14.8487C21.5619 14.9566 21.649 15.1283 21.649 15.3109V34.1728C21.649 34.4891 21.3926 34.7455 21.0763 34.7455C21.0635 34.7455 21.0508 34.7451 21.0381 34.7442C21.0255 34.7451 21.0128 34.7455 21 34.7455H2.29087C1.97456 34.7455 1.71814 34.4891 1.71814 34.1728V15.1964C1.71814 15.0121 1.8068 14.8391 1.95637 14.7315L11.3491 7.97331ZM20.5036 33.6V15.6015L11.6808 9.14581L2.86359 15.4899V33.6H20.5036Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.3499 5.07091C11.5489 4.92823 11.8166 4.92783 12.016 5.0699L20.9123 11.4081C21.1699 11.5916 21.23 11.9492 21.0465 12.2069C20.8629 12.4645 20.5053 12.5245 20.2477 12.341L11.6847 6.24033L0.142839 14.5163C-0.114216 14.7007 -0.472021 14.6417 -0.656341 14.3846C-0.84066 14.1276 -0.781696 13.7698 -0.524641 13.5855L11.3499 5.07091Z"
            fill="currentColor"
          />
          <path d="M9.85097 18.2891H6.49097V22.4891H9.85097V18.2891Z" fill="currentColor" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.91821 18.289C5.91821 17.9727 6.17463 17.7163 6.49094 17.7163H9.85094C10.1672 17.7163 10.4237 17.9727 10.4237 18.289V22.489C10.4237 22.8053 10.1672 23.0618 9.85094 23.0618H6.49094C6.17463 23.0618 5.91821 22.8053 5.91821 22.489V18.289ZM7.06367 18.8618V21.9163H9.27821V18.8618H7.06367Z"
            fill="currentColor"
          />
          <path d="M17.1055 18.2891H13.7455V22.4891H17.1055V18.2891Z" fill="currentColor" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.1727 18.289C13.1727 17.9727 13.4291 17.7163 13.7455 17.7163H17.1055C17.4218 17.7163 17.6782 17.9727 17.6782 18.289V22.489C17.6782 22.8053 17.4218 23.0618 17.1055 23.0618H13.7455C13.4291 23.0618 13.1727 22.8053 13.1727 22.489V18.289ZM14.3182 18.8618V21.9163H16.5327V18.8618H14.3182Z"
            fill="currentColor"
          />
          <path d="M9.85097 25.5054H6.49097V29.7054H9.85097V25.5054Z" fill="currentColor" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.91821 25.5053C5.91821 25.189 6.17463 24.9326 6.49094 24.9326H9.85094C10.1672 24.9326 10.4237 25.189 10.4237 25.5053V29.7053C10.4237 30.0217 10.1672 30.2781 9.85094 30.2781H6.49094C6.17463 30.2781 5.91821 30.0217 5.91821 29.7053V25.5053ZM7.06367 26.0781V29.1326H9.27821V26.0781H7.06367Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.1727 25.5053C13.1727 25.189 13.4291 24.9326 13.7455 24.9326H17.1055C17.4218 24.9326 17.6782 25.189 17.6782 25.5053V34.1726C17.6782 34.4889 17.4218 34.7453 17.1055 34.7453H13.7455C13.4291 34.7453 13.1727 34.4889 13.1727 34.1726V25.5053ZM14.3182 26.0781V33.5999H16.5327V26.0781H14.3182Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.18359 37.4182C1.18359 37.1019 1.44001 36.8455 1.75632 36.8455H39.9381C40.2544 36.8455 40.5109 37.1019 40.5109 37.4182C40.5109 37.7345 40.2544 37.9909 39.9381 37.9909H1.75632C1.44001 37.9909 1.18359 37.7345 1.18359 37.4182Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="42" height="42" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  },
);
